import { useState } from 'react'
import { IEmployeeAvatar } from 'types/ui/employeeAvatar.interface'
import { AvatarRoot } from './EmployeeAvatar.styled'

const getInitials = (name?: string) => {
  if (!name) return '?'
  const parts = name.trim().split(/\s+/)
  return ((parts[0]?.[0] || '') + (parts[1]?.[0] || '')).toUpperCase()
}

export const EmployeeAvatar = ({ src, name, size, onClick }: IEmployeeAvatar) => {
  const [errored, setErrored] = useState(false)
  const showImage = Boolean(src) && !errored

  return (
    <AvatarRoot $size={size} $clickable={Boolean(onClick)} onClick={onClick}>
      {showImage ? (
        <img src={src as string} alt='' onError={() => setErrored(true)} />
      ) : (
        getInitials(name)
      )}
    </AvatarRoot>
  )
}
